export const RNLoginManager = {
  logInWithPermissions: () => {},
  logOut: () => {},
};
export const RNAccessToken = {
  getCurrentAccessToken: () => {},
};
